import { render, staticRenderFns } from "./BaseTranslateCountry.vue?vue&type=template&id=846a12c4&scoped=true&"
import script from "./BaseTranslateCountry.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseTranslateCountry.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseTranslateCountry.vue?vue&type=style&index=0&id=846a12c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846a12c4",
  null
  
)

export default component.exports